import { BlockchainType } from '@shared/types/services/enums';
import executeViaClientSolana from './executeViaClientSolana';
import executeViaClientEVM from './executeViaClientEVM';
import executeViaClientSui from './executeViaClientSui';
export default async function executeViaClient({
  params,
  pkp,
  orderType,
  dbOrderParams,
  keypair,
  signer,
  suiKeyPair,
  existingdbOrder,
  skipSimulation,
  blockchainType,
  additionalExecutionTime,
  additionalDecodedResponse,
  transferParams
}) {
  if (blockchainType === BlockchainType.SVM) {
    return executeViaClientSolana({
      params,
      pkp,
      orderType,
      dbOrderParams,
      keypair,
      existingdbOrder,
      skipSimulation,
      transferParams
    });
  } else if (blockchainType === BlockchainType.EVM) {
    return executeViaClientEVM({
      params,
      pkp,
      orderType,
      dbOrderParams,
      signer,
      existingdbOrder,
      skipSimulation: true,
      additionalExecutionTime,
      additionalDecodedResponse,
      transferParams
    });
  } else if (blockchainType === BlockchainType.MOVE) {
    return executeViaClientSui({
      params,
      pkp,
      suiKeyPair,
      orderType,
      dbOrderParams,
      existingdbOrder,
      transferParams
    });
  }
}